import React from "react";
import FuraAI from "./FuraAI";

function App() {
  return <FuraAI />;
}

export default App;

